import NiceModal from '@ebay/nice-modal-react'
import { UserApi, UserProfileModel } from 'mvppoker-portal-common/api'
import React, { ChangeEvent, useMemo, useState } from 'react'
import toast from 'react-hot-toast'
import { updateService } from '../../../../logic/UpdateService'
import { useActiveUser } from '../../../../state/hooks/ActiveUserHooks'
import { useOtherProfilesLookup } from '../../../../state/hooks/ProfileDataHooks'
import { handleError, useApi } from '../../../../utils/useApi'
import { createMVPModal } from '../../Modal'
import UserProfileModal from '../../PlayerModal/UserProfileModal'
import { FriendsFindModalView } from './FriendsFindModalView'

class FriendsFindModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('friends-find-modal', () =>
		{
			const user = useActiveUser()
			const otherProfilesLookup = useOtherProfilesLookup()
			const api = useApi(UserApi)
			const [isRefreshing, setRefreshing] = useState(false)
			const [inputText, setInputText] = useState('')

			const searchCallback = (input: string) => {
			  setInputText(input.toLowerCase())
			}

			const allProfiles = useMemo(() => {
				if (user){
					const userId = user.user.id
					const { friends, requestsSent, requestsReceived } = user.user.friends
					const otherProfiles = Object.keys(otherProfilesLookup)

					return otherProfiles.filter((id) => userId !== id && !friends.includes(id) && !requestsReceived.includes(id) && !requestsSent.includes(id)).map(id => otherProfilesLookup[id])
				}
				return []
			}, [user])

			const profiles = useMemo(() => {
				return inputText.length > 0 ? allProfiles.filter(p => p.info.name.toLowerCase().includes(inputText) ) : allProfiles
			}, [inputText, allProfiles])

			const clickRefresh = () => {
				setRefreshing(true)
		
				updateService.refreshOtherProfiles(() => {
					setRefreshing(false)
				})
			}
			const clickProfile = (profile: UserProfileModel) => {
				UserProfileModal.Show(profile)
			}

			const clickInvite = (profile: UserProfileModel) => {
				api
				.usersFriendsRequest({ value: profile.userId })
				.then(() => {
					toast.success('Friend Request Sent!')
					clickRefresh()
				})
				.catch((err) => {
					handleError(err)
				})
			}

			return <FriendsFindModalView 
				profiles={profiles}
	
				clickRefresh={clickRefresh}
				isRefreshing={isRefreshing}
				searchCallback={searchCallback}
				friendsFindListItemActions={{
					clickInvite,
					clickProfile,
				}}
			/>
		}))
	}
}

const modal = new FriendsFindModal()
export default modal
